import { __awaiter, __generator, __rest } from "tslib";
export var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
  return function (next, context) {
    return function (args) {
      return __awaiter(void 0, void 0, void 0, function () {
        var logger, outputFilterSensitiveLog, response, parsed, $metadata, outputWithoutMetadata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4
              /*yield*/
              , next(args)];

            case 1:
              response = _a.sent().response;

              if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") {
                logger.debug({
                  httpResponse: response
                });
              }

              return [4
              /*yield*/
              , deserializer(response, options)];

            case 2:
              parsed = _a.sent();
              $metadata = parsed.$metadata, outputWithoutMetadata = __rest(parsed, ["$metadata"]);

              if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") {
                logger.info({
                  output: outputFilterSensitiveLog(outputWithoutMetadata)
                });
              }

              return [2
              /*return*/
              , {
                response: response,
                output: parsed
              }];
          }
        });
      });
    };
  };
};